import React from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools } from "lib/utils"
import { TemplateRenderWrapper } from "lib/designs/defleppard"
import { Presets } from "lib/units/template/build"

export default function PreviewWrapper(){

  const { tmplid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams();
    
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { update } = AppStore
  
  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", {_id: tmplid }, { enabled: !!tmplid })

  return (
    <div className="w-full h-full bg-transparent flex justify-start *:text-gray-900 relative overflow-y-auto">
      <Presets location="preview" template={_Template} />

      { store.presets.active === null && (
        <div className="w-4/12 h-36 flex justify-center items-center">
          <p className="text-neutral-200 text-center">Use the presets tab along the right edge to choose a preset dispute to work with.</p>
        </div>
      )}
      <TemplateRenderWrapper
        ready={store.presets.ready}
        template={_Template}
        subdomain={store.presets.active?.subdomain}
        rp={store.presets.active?.rp}
        renderconfig={{ 
          mode: "page", 
          height: "auto", 
          width: "990px", 
          scale: 1.0,
        }}
      />
    </div>
  )

}